var map = {
	"./230419_news_gt-rutas-encanto.pdf": "./src/assets/documents/230419_news_gt-rutas-encanto.pdf",
	"./Area-de-validacion-Swiss-half-fare-card.pdf": "./src/assets/documents/Area-de-validacion-Swiss-half-fare-card.pdf",
	"./British-Explorer.pdf": "./src/assets/documents/British-Explorer.pdf",
	"./BritishPulman.pdf": "./src/assets/documents/BritishPulman.pdf",
	"./BrochureRVR.pdf": "./src/assets/documents/BrochureRVR.pdf",
	"./Check-In-trenes-regionales-NOTVALID-Italia.pdf": "./src/assets/documents/Check-In-trenes-regionales-NOTVALID-Italia.pdf",
	"./Como-descargar-e-tickets-ITALO-y-OUIGO.pdf": "./src/assets/documents/Como-descargar-e-tickets-ITALO-y-OUIGO.pdf",
	"./Como-leer-los-e-tickets-en-aleman-deDB.pdf": "./src/assets/documents/Como-leer-los-e-tickets-en-aleman-deDB.pdf",
	"./Europa-en-tren-Guia-Oficial-2022.pdf": "./src/assets/documents/Europa-en-tren-Guia-Oficial-2022.pdf",
	"./Go-Trenes-Instructivo-Tickets.pdf": "./src/assets/documents/Go-Trenes-Instructivo-Tickets.pdf",
	"./GoTrenes-Instructivo-Pases.pdf": "./src/assets/documents/GoTrenes-Instructivo-Pases.pdf",
	"./GoldenEagleLuxuryTrain.pdf": "./src/assets/documents/GoldenEagleLuxuryTrain.pdf",
	"./Greek-Island-passes-guide-2023.pdf": "./src/assets/documents/Greek-Island-passes-guide-2023.pdf",
	"./Greek-Island-passes-guide-2024.pdf": "./src/assets/documents/Greek-Island-passes-guide-2024.pdf",
	"./Instructivo-pases-suizos.pdf": "./src/assets/documents/Instructivo-pases-suizos.pdf",
	"./InstructivoPlanillaGrupos.csv": "./src/assets/documents/InstructivoPlanillaGrupos.csv",
	"./LaDolceVita.pdf": "./src/assets/documents/LaDolceVita.pdf",
	"./Mapa-de-trenes-Rail-Europe.pdf": "./src/assets/documents/Mapa-de-trenes-Rail-Europe.pdf",
	"./Mapa-de-trenes-suizos.pdf": "./src/assets/documents/Mapa-de-trenes-suizos.pdf",
	"./Politica-de-beneficios-Pases-EURAIL-2022.pdf": "./src/assets/documents/Politica-de-beneficios-Pases-EURAIL-2022.pdf",
	"./Politicas-tarifarias-para-pasajeros-Child-e-Infant.pdf": "./src/assets/documents/Politicas-tarifarias-para-pasajeros-Child-e-Infant.pdf",
	"./Renfe.pdf": "./src/assets/documents/Renfe.pdf",
	"./Rocky-Mountaineer.pdf": "./src/assets/documents/Rocky-Mountaineer.pdf",
	"./RoyalScotsman.pdf": "./src/assets/documents/RoyalScotsman.pdf",
	"./VeniceSimplonOrientExpress.pdf": "./src/assets/documents/VeniceSimplonOrientExpress.pdf",
	"./andalucia-en-tren.pdf": "./src/assets/documents/andalucia-en-tren.pdf",
	"./camino-de-santiago.pdf": "./src/assets/documents/camino-de-santiago.pdf",
	"./categorias-GO.pdf": "./src/assets/documents/categorias-GO.pdf",
	"./costa-azul-en-tren.pdf": "./src/assets/documents/costa-azul-en-tren.pdf",
	"./instructivo-equipaje.pdf": "./src/assets/documents/instructivo-equipaje.pdf",
	"./mapa-trenes-EEUU.pdf": "./src/assets/documents/mapa-trenes-EEUU.pdf",
	"./norte-de-italia-en-tren.pdf": "./src/assets/documents/norte-de-italia-en-tren.pdf",
	"./recorre-alemania-en-tren.pdf": "./src/assets/documents/recorre-alemania-en-tren.pdf",
	"./reglas-de-equipaje-ferroviario.pdf": "./src/assets/documents/reglas-de-equipaje-ferroviario.pdf",
	"./reino-unido-en-tren.pdf": "./src/assets/documents/reino-unido-en-tren.pdf",
	"./ruta-de-invierno.pdf": "./src/assets/documents/ruta-de-invierno.pdf",
	"./sample.pdf": "./src/assets/documents/sample.pdf",
	"./toscana-en-tren.pdf": "./src/assets/documents/toscana-en-tren.pdf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/documents sync recursive ^\\.\\/.*$";